<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Documentos</span>
                    </b-card-header>
                    <b-card-body>
                        <app-tabela
                            idTabela="tblAnexos"
                            :itens="anexos"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="primary"
                                        @click.stop="inserirAnexo()"
                                        v-if="mostrarBtnInserirAnexo"
                                        ><i class="fa fa-plus"></i> Inserir
                                        Documento</b-button
                                    >
                                    <b-button
                                        variant="warning"
                                        @click.stop="$emit('fechar')"
                                        ><i class="fa fa-times-circle"></i>
                                        Fechar Anexos</b-button
                                    >
                                </b-button-group>
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <finalizacao-anexo-download
                                    :finalizacaoAnexo="data"
                                    :finalizacoesServicos="finalizacoesServicos"
                                ></finalizacao-anexo-download>
                                <finalizacao-anexos-excluir
                                    :finalizacao="finalizacao"
                                    :finalizacaoAnexo="data"
                                    :finalizacoesServicos="finalizacoesServicos"
                                    @obterFinalizacaoAtualizada="
                                        obterFinalizacaoAtualizada()
                                    "
                                    class="ml-1"
                                    v-if="mostrarBtnExcluirAnexo"
                                ></finalizacao-anexos-excluir>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <finalizacao-anexo-form
            ref="finalizacaoAnexoForm"
            @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
            :finalizacao="finalizacao"
            :finalizacoesServicos="finalizacoesServicos"
        ></finalizacao-anexo-form>
    </div>
</template>

<script>
import FinalizacaoAnexoDownload from './FinalizacaoAnexoDownload'
import FinalizacaoAnexoForm from './FinalizacaoAnexoForm'
import FinalizacaoAnexosExcluir from './FinalizacaoAnexosExcluir'

export default {
    props: {
        finalizacao: {
            type: Object,
            default: () => ({})
        },

        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            anexos: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'anexoTipoDescr',
                    label: 'Tipo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descritivo',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeArquivoOriginal',
                    label: 'Arquivo'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        obterAnexos() {
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos
                .obterAnexos(this.$route.params.finalizacaoId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.anexos = response.data
                        } else {
                            this.$toast.error(
                                'Não foi possível obter os documentos.',
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        inserirAnexo() {
            this.$refs.finalizacaoAnexoForm.mostrarModalFinalizacaoAnexoForm = true
        },

        obterFinalizacaoAtualizada() {
            this.obterAnexos()
        }
    },

    computed: {
        mostrarBtnInserirAnexo() {
            return this.$temAcesso('CRED-FIN-ANX-01')
        },

        mostrarBtnExcluirAnexo() {
            return this.$temAcesso('CRED-FIN-ANX-02')
        }
    },

    created() {
        this.obterAnexos()
    },

    components: {
        FinalizacaoAnexoForm,
        FinalizacaoAnexoDownload,
        FinalizacaoAnexosExcluir
    }
}
</script>
